var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[(!_vm.showMsg)?_c('Icon',{staticClass:"icon",attrs:{"type":"loading"}}):_c('span',[_vm._v(_vm._s(_vm.noMoreMsg))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }